import React from "react";

const features = [
  {
    icon: "fa-users",
    number: "01",
    title: "AI-Powered Content Generation",
    description: "Generate engaging posts, captions, and hashtags using advanced AI.",
  },
  {
    icon: "fa fa-clock-o",
    number: "02",
    title: "Automated Scheduling & Posting",
    description: "Plan and schedule posts across multiple platforms. Let AI determine the best time to post for maximum engagement.",
  },
  {
    icon: "fa fa-cogs",
    number: "03",
    title: "Reports & Insights",
    description: "Track performance with AI-driven insights. Get reports on engagement, audience growth, and content effectiveness in real time.",
  },
  {
    icon: "fa-question-circle",
    number: "04",
    title: "Multi-Platform Management",
    description: "Manage all your social media accounts from one dashboard. Create, schedule, and analyze content seamlessly across different platforms.",
  },
];

const WorkProcess = () => {
  return (
    <div className="work-process-area overflow-hidden bottom-less">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 offset-lg-2">
            <div className="site-heading text-center">
              <h2>Core Features</h2>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="work-pro-items">
          <div className="row">
            {features.map((feature, index) => (
              <div className="single-item col-lg-3 col-md-6 col-sm-12" key={index}>
                <div className="item">
                  <div className="item-inner">
                    <div className="icon">
                      <i className={`fa ${feature.icon}`} style={{ fontSize: 60, color: "#2e3192", marginBottom: 30 }}></i>
                      <span>{feature.number}</span>
                    </div>
                    <h5>{feature.title}</h5>
                    <p>{feature.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <style jsx>
          {`
            .site-heading h2 {
              display: inline-block;
              font-weight: 600;
              padding-bottom: 20px;
              margin-bottom: 0;
              position: relative;
              letter-spacing: 1px;
              line-height: 1.4;
              margin-top: 40px;
            }
            .site-heading h2::before {
              background: #086ad8 none repeat scroll 0 0;
              bottom: 0;
              content: "";
              height: 2px;
              left: 50%;
              margin-left: -25px;
              position: absolute;
              width: 50px;
            }
            .work-process-area .work-pro-items .item i {
              display: inline-block;
              color: #086ad8;
              font-size: 60px;
              margin-bottom: 30px;
            }
            .work-process-area .work-pro-items .item {
              border: 1px solid #e7e7e7;
              padding: 50px 30px;
              background: #ffffff;
              position: relative;
              z-index: 1;
              overflow: hidden;
              height: 290px;
              margin-bottom: 30px;
            }
            .work-process-area .work-pro-items .item .icon {
              position: relative;
            }
            .work-process-area .work-pro-items .item h5 {
              position: relative;
              z-index: 1;
              font-weight: 600;
              font-size: 18px;
            }
            .work-process-area .work-pro-items .item p {
              margin: 0;
            }
            .work-process-area .work-pro-items .item .icon span {
              position: absolute;
              left: 15px;
              top: 0;
              font-size: 100px;
              z-index: -1;
              color: #f4f4f4;
              opacity: 0.9;
              font-weight: 900;
              color: transparent;
              -webkit-text-stroke: 2px #f4f4f4;
              line-height: 50px;
              font-family: sans-serif;
            }
            /* Responsive Styles */
            @media (max-width: 992px) {
              .work-process-area .work-pro-items .item {
                height: auto;
                padding: 40px 20px;
              }
              .work-process-area .work-pro-items .item i {
                font-size: 50px;
              }
              .work-process-area .work-pro-items .item h5 {
                font-size: 16px;
              }
              .work-process-area .work-pro-items .item p {
                font-size: 14px;
              }
            }

            @media (max-width: 768px) {
              .work-process-area .work-pro-items .item {
                padding: 30px 15px;
              }
              .work-process-area .work-pro-items .item i {
                font-size: 45px;
              }
              .work-process-area .work-pro-items .item h5 {
                font-size: 15px;
              }
              .work-process-area .work-pro-items .item p {
                font-size: 13px;
              }
            }

            @media (max-width: 576px) {
              .work-process-area .work-pro-items .item {
                padding: 25px 10px;
                height: auto;
              }
              .work-process-area .work-pro-items .item i {
                font-size: 40px;
              }
              .work-process-area .work-pro-items .item h5 {
                font-size: 14px;
              }
              .work-process-area .work-pro-items .item p {
                font-size: 12px;
              }
            }

          `}
        </style>
      </div>
    </div>
  );
};

export default WorkProcess;
